import { render } from "./SupervisionModePageList.vue?vue&type=template&id=88c4c7fc&scoped=true&ts=true"
import script from "./SupervisionModePageList.vue?vue&type=script&lang=ts"
export * from "./SupervisionModePageList.vue?vue&type=script&lang=ts"

import "./SupervisionModePageList.vue?vue&type=style&index=0&id=88c4c7fc&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c4c7fc"]])

export default __exports__